import { gql } from "@apollo/client";

/**
 * GraphQL fields used by both Create and Update mutations. The
 * private API auto-generates input args from BlogPost columns and
 * accepts `tagNames` as an extra argument that drives the find-or-
 * create + sync logic on the server.
 */
const BLOG_POST_FIELDS = `
  id
  tenantId
  title
  slug
  author
  summary
  body
  publishAt
  featuredImageUrl
  featuredImageAlt
  status
  tagNames
  createdAt
  updatedAt
`;

export const CREATE_BLOG_POST = gql`
  mutation CreateBlogPost(
    $title: String!
    $slug: String!
    $author: String!
    $summary: String
    $body: String
    $publishAt: DateTime
    $featuredImageUrl: String
    $featuredImageAlt: String
    $tagNames: [String]
  ) {
    createBlogPost(
      title: $title
      slug: $slug
      author: $author
      summary: $summary
      body: $body
      publishAt: $publishAt
      featuredImageUrl: $featuredImageUrl
      featuredImageAlt: $featuredImageAlt
      tagNames: $tagNames
    ) {
      ${BLOG_POST_FIELDS}
    }
  }
`;

export const UPDATE_BLOG_POST = gql`
  mutation UpdateBlogPost(
    $id: String!
    $title: String
    $slug: String
    $author: String
    $summary: String
    $body: String
    $publishAt: DateTime
    $featuredImageUrl: String
    $featuredImageAlt: String
    $tagNames: [String]
  ) {
    updateBlogPost(
      id: $id
      title: $title
      slug: $slug
      author: $author
      summary: $summary
      body: $body
      publishAt: $publishAt
      featuredImageUrl: $featuredImageUrl
      featuredImageAlt: $featuredImageAlt
      tagNames: $tagNames
    ) {
      ${BLOG_POST_FIELDS}
    }
  }
`;

export const DELETE_BLOG_POST = gql`
  mutation DeleteBlogPost($id: String!) {
    deleteBlogPost(id: $id) {
      id
    }
  }
`;
